import { v4 as uuidv4 } from "uuid";

const NotificationEmailType = Symbol();

// 通知先情報をリストにした場合の最大長
export const NotificationEmailListMaxLength = 10;

export class NotificationEmail {
    [NotificationEmailType]: any;
    // mapのkey用
    readonly id: string;
    readonly value: string;

    private constructor(id: string, email: string) {
        this.id = id;
        this.value = email;
    }

    // メールアドレスのフォーマットチェック
    isValid(): boolean {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.value);
    }

    static from(email: string): NotificationEmail {
        return new NotificationEmail(uuidv4(), email);
    }

    static fromString(id: string, email: string): NotificationEmail {
        return new NotificationEmail(id, email);
    }

    static fromNothing(): NotificationEmail {
        return new NotificationEmail(uuidv4(), "");
    }
}

export type NotificationEmailJson = {
    email: string
};
